import { render, staticRenderFns } from "./BookSubShelvesManage.vue?vue&type=template&id=0d7ca7ff&scoped=true"
import script from "./BookSubShelvesManage.vue?vue&type=script&lang=js"
export * from "./BookSubShelvesManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7ca7ff",
  null
  
)

export default component.exports